import { AbilityService as BaseAbilityService } from '@efdigital/ll-addon-auth';

import { ABILITIES } from '../config/abilities.ts';

/**
 * Application-specific ability service for ll-admin-v2.
 *
 * Provides authorization checks by extending ll-addon-auth's AbilityService
 * with the application's ability configuration from config/abilities.ts.
 *
 * The configuration maps ability names to required JWT rights at each access level.
 * Rights are extracted from the user's ID token claim 'https://va/r'.
 *
 * @example
 * ```ts
 * import Component from '@glimmer/component';
 * import { service } from '@ember/service';
 * import type AbilityService from '@efdigital/ll-admin-v2/services/ability';
 *
 * export default class MyComponent extends Component {
 *   @service declare readonly ability: AbilityService;
 *
 *   get canEditPrograms() {
 *     return this.ability.canEdit('programs');
 *   }
 * }
 * ```
 */
export default class AbilityService extends BaseAbilityService {
  abilityMap = ABILITIES;
}

// Type registration for Ember's DI system
declare module '@ember/service' {
  interface Registry {
    ability: AbilityService;
  }
}
